import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { GetClientsListForVendorPayload } from "../../payload/GetClientsListForVendor/GetClientsListForVendorPayload";

const getClientsListForVendorFetch = (state: ClientsState, actions: PayloadAction<GetClientsListForVendorPayload>) => {
    state.isLoading = true;
}

export default getClientsListForVendorFetch;